import { applyFilter as applyAttributeFilter } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/filters/attribute-filter';
import {
	getIssueStatuses,
	type IssueStatus,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issue-statuses';
import { getFiltersViewSettings } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/view-settings';
import type { Issue } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/issues/types';
import {
	type StatusFilter,
	STATUS_FILTER_ID,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/view-settings/filters/types';

import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import { UNDEFINED_KEY } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';

// eslint-disable-next-line jira/export/no-external-exports
export type { StatusFilter } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/view-settings/filters/types';
export const UNSAVED_STATUS = { id: UNDEFINED_KEY, categoryId: 2, name: 'UNSAVED' } as const;

// eslint-disable-next-line jira/export/no-external-exports
export { STATUS_FILTER_ID } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/view-settings/filters/types';

export const applyFilter = (issue: Issue, filter: StatusFilter, optimizedMode: boolean): boolean =>
	applyAttributeFilter(issue, filter.value, 'status', optimizedMode);

export const getStatusFilterPure = (state: State): StatusFilter =>
	getFiltersViewSettings(state)[STATUS_FILTER_ID] || {
		id: STATUS_FILTER_ID,
		value: [],
	};

export const getStatusFilter = createSelector(
	[getIssueStatuses, getStatusFilterPure],
	(issueStatuses: IssueStatus[], pureFilter: StatusFilter): StatusFilter => {
		const { value = [] } = pureFilter;
		const existingStatuses = value.filter(
			(status: string) =>
				issueStatuses.some((issueStatus) => issueStatus.id === status) ||
				status === UNSAVED_STATUS.id,
		);
		return {
			id: STATUS_FILTER_ID,
			value: existingStatuses,
		};
	},
);

export const getIssueStatusFilterOptions = createSelector(
	[getIssueStatuses],
	(issueStatuses: IssueStatus[]) => [...issueStatuses, UNSAVED_STATUS],
);
